<script>
    import ContentSection from "../ContentSection.svelte";
    import {_} from "svelte-i18n";

    export let phone;
    export let email;

    $: emailLink = `mailto:${email}?subject=Mein%20Besuch%20bei%20der%20Fondation%20Beyeler`;
</script>

<ContentSection title={$_("contact_title")}>
    <div slot="content" class="content">
        <div class="contact-row">
            <img
                    src="./images/icons/phone.svg"
                    alt={$_("contact_phone_alt")}
                    class="contact-icon"
            />
            <span class="text-l">{phone}</span>
        </div>
        <div class="contact-row">
            <img
                    src="./images/icons/mail.svg"
                    alt={$_("contact_email_alt")}
                    class="contact-icon"
            />
            <a href={emailLink} class="text-l">{email}</a>
        </div>
    </div>
</ContentSection>

<style>
    .contact-row {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
    }

    .contact-icon {
        width: 16px;
        height: 16px;
        margin-right: 16px;
    }

    .content {
        padding: 16px 0;
    }
</style>
